/**
 * Convert a camelCase variable name to a label
 * "facilityName" to "Facility Name"
 */
export function toLabel(name: string): string {
    return name
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (c) => c.toUpperCase())
        .trim();
}

/**
 * Convert a label to camelCase
 * "Facility Name" to "facilityName"
 */
export function toName(label: string): string {
    return label
        .trim()
        .replace(/[^a-zA-Z0-9\s]/g, '')
        .split(/\s+/)
        .filter(Boolean)
        .map((word, i) =>
            i === 0
                ? word.toLowerCase()
                : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join('');
}
